export default __webpack_public_path__ + "static/media/tempologo.6d598855.png";